export default __webpack_public_path__ + "static/media/poster-illustration.ec9cacc3.svg";